import { apiStatic, getRandomString, requestError } from 'AurionCR/components';
import { notifyRequestResult } from 'AurionCR/store/modules/notify';
import axios from 'axios';
import {
  iRatingProcessPreview,
  iRatingProcessPreviews,
} from 'components/rating-process-preview/@type';
import { useEffect, useState } from 'react';
import { API_RATING_PROCESS } from 'services/rating-process';
import { useAppDispatch } from 'store';
import { queryEncoderObject } from '../helpers.ts';

const select = [
  'id',
  'createdDate',
  'ratedEntity.name as ratedEntityName',
  'department.title as departmentTitle',
  'ratingProcessType.title as ratingProcessTypeTitle',
  // 'title',
  'ratingProcessStatusID',
  'isCompleted',
  'completeRatingProcessDate',
  `ratingProcessSteps
    .OrderBy(o=>o.ratingProcessStepTypeID)
    .Select(s=>new {${[
      's.id',
      's.ratingProcessID',
      's.ratingProcessStepTypeID',
      's.ratingProcessStepType.title as ratingProcessStepTypeTitle',
      's.headOfFieldSignatureDate',
      's.isCompleted',
    ].join()}}).toList() as ratingProcessSteps`.replace(/  +|\r\n|\n|\r/gm, ''),
].join();

type FilterType = 'ratedEntityID' | 'orderID';

interface UseGetRatingProcessesDataOptions {
  filterType: FilterType;
  filterValue: number;
}

interface UseGetRatingProcessesDataResult {
  loading: boolean;
  data: iRatingProcessPreviews | null;
  onReload: () => void;
}

export const useGetRatingProcessesData = ({
  filterType,
  filterValue,
}: UseGetRatingProcessesDataOptions): UseGetRatingProcessesDataResult => {
  const dispatch = useAppDispatch();
  // state
  const [loading, setLoading] = useState(false);
  const [triggerReload, setTriggerReload] = useState(getRandomString());
  const [data, setData] = useState<iRatingProcessPreviews | null>(null);
  // handlers
  const onReload = () => {
    setTriggerReload(getRandomString());
  };
  // init
  useEffect(() => {
    const CancelToken = axios.CancelToken;
    let cancel: any;
    if (filterValue) {
      setLoading(true);
      const cancelToken = new CancelToken(function executor(c) {
        cancel = c;
      });
      Promise.all([
        apiStatic.post<{ value: iRatingProcessPreview[] }>(
          API_RATING_PROCESS.GET_ALL_DYNAMIC,
          queryEncoderObject({
            select,
            filter: `ratingProcessStatusID==1&&${filterType}==${filterValue}`,
            orderBy: 'id desc',
            take: 10,
          }),
          {
            cancelToken,
          },
        ),
        apiStatic.post<{ value: iRatingProcessPreview[] }>(
          API_RATING_PROCESS.GET_ALL_DYNAMIC,
          queryEncoderObject({
            select,
            filter: `ratingProcessStatusID==2&&${filterType}==${filterValue}`,
            orderBy: 'id desc',
            take: 10,
          }),
          {
            cancelToken,
          },
        ),
        apiStatic.post<{ value: iRatingProcessPreview[] }>(
          API_RATING_PROCESS.GET_ALL_DYNAMIC,
          queryEncoderObject({
            select,
            filter: `ratingProcessStatusID==3&&${filterType}==${filterValue}`,
            orderBy: 'id desc',
            take: 10,
          }),
          {
            cancelToken,
          },
        ),
      ])
        .then(
          ([
            {
              data: { value: active },
            },
            {
              data: { value: rejected },
            },
            {
              data: { value: completed },
            },
          ]) => {
            setData({ active, rejected, completed });
          },
        )
        .catch((e) => {
          if (!axios.isCancel(e)) {
            dispatch(notifyRequestResult(requestError(e, e.message), 'error'));
          } else {
            setData(null);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    }
    return () => {
      if (cancel) cancel();
    };
  }, [filterValue, dispatch, filterType, triggerReload]);
  // results
  return { loading, data, onReload };
};
